import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const setRemixThinkingComplete =
	(isComplete: boolean): EditorCommand =>
	({ tr }) => {
		tr.setMeta(remixThinkingPluginKey, {
			isComplete,
		} satisfies RemixThinkingPluginMeta);

		return tr;
	};
